module.exports = __webpack_public_path__ + "static/jeans-789d23f9e47096040bbe700239bb1782.jpg";